/**
 * Submit Support Request UseCase
 *
 * Submits a contact / support request via ContactSupportService.
 *
 * Pattern from Flutter: `CloudFunctionsService.submitSupportRequest`
 * called directly from `lib/presentation/web/contact_screen.dart:226-231`.
 * The web port adds this use-case wrapper per project Clean Architecture
 * conventions (see `domain/usecases/report/submitUserReportUseCase.ts`).
 */

import { contactSupportService } from '@/domain/services/contactSupport/contactSupportService';

export class SubmitSupportRequestUseCase {
  /**
   * Submit a support request.
   *
   * @param content - Optional free-text request body. Empty string is
   *                  forwarded unchanged (Flutter's content field is
   *                  optional — see `contact_screen.dart:227`).
   * @param emailAddress - The user-supplied contact email (validated by
   *                       the caller before invoking this use case).
   * @returns `true` when the cloud function reports success, `false`
   *          otherwise. Errors from the service propagate — the data
   *          layer is expected to catch and return `false` on its own.
   */
  async execute(content: string, emailAddress: string): Promise<boolean> {
    return contactSupportService.submitSupportRequest(content, emailAddress);
  }
}

export const submitSupportRequestUseCase = new SubmitSupportRequestUseCase();
